<template>
  <div class="account-edit-page">
    <div class="card">
      <div class="card-header">
        <h2>Modifier les informations du compte</h2>
        <p class="subtitle">Informations du compte</p>
      </div>

      <form @submit.prevent="save" class="form">
        <!-- Type de client -->
        <div class="form-row">
          <label class="label">Type de client <span class="req">*</span></label>
          <div class="radio-group">
            <label>
              <input type="radio" value="pro" v-model="form.clientType" />
              Client professionnel
            </label>
            <label>
              <input type="radio" value="priv" v-model="form.clientType" />
              Client privé
            </label>
          </div>
          <p v-if="errors.clientType" class="error">{{ errors.clientType }}</p>
        </div>

        <!-- Préfixe -->
        <div class="form-row">
          <label class="label">Préfixe de nom <span class="req">*</span></label>
          <select v-model="form.civilite" required>
            <option value="Monsieur">Monsieur</option>
            <option value="Madame">Madame</option>
          </select>
        </div>

        <!-- Prénom -->
        <div class="form-row">
          <label class="label">Prénom <span class="req">*</span></label>
          <input type="text" v-model="form.prenom" required />
          <p v-if="errors.prenom" class="error">{{ errors.prenom }}</p>
        </div>

        <!-- Nom -->
        <div class="form-row">
          <label class="label">Nom <span class="req">*</span></label>
          <input type="text" v-model="form.nom" required />
          <p v-if="errors.nom" class="error">{{ errors.nom }}</p>
        </div>

        <!-- TVA (si tu en as besoin, dé-commente)
        <div class="form-row">
          <label class="label">Numéro de TVA <span v-if="form.clientType==='pro'" class="req">*</span></label>
          <input type="text" v-model="form.vatNumber" :required="form.clientType==='pro'" />
          <p v-if="errors.vatNumber" class="error">{{ errors.vatNumber }}</p>
        </div>
        -->

        <!-- Modifier l'email -->
        <div class="form-row checkbox-row">
          <label>
            <input type="checkbox" v-model="editEmail" />
            Modifier l'email
          </label>
        </div>

        <div v-if="editEmail" class="fieldset">
          <div class="form-row">
            <label class="label">Nouvel email <span class="req">*</span></label>
            <input type="email" v-model="emailFields.newEmail" />
            <p v-if="errors.newEmail" class="error">{{ errors.newEmail }}</p>
          </div>
          <div class="form-row">
            <label class="label">Confirmer le nouvel email <span class="req">*</span></label>
            <input type="email" v-model="emailFields.confirmEmail" />
            <p v-if="errors.confirmEmail" class="error">{{ errors.confirmEmail }}</p>
          </div>
        </div>

   <!-- Modifier le mot de passe -->
<div class="form-row checkbox-row">
  <!-- Le label force l’activation -->
  <label class="label-toggle" @click.prevent="enablePasswordEdit">
    <!-- Le clic sur la case reste normal (peut décocher) -->
    <input type="checkbox" v-model="editPassword" @click.stop />
    Modifier le mot de passe
  </label>
</div>

<div v-if="editPassword" class="fieldset">
  <div class="form-row">
    <label class="label">Mot de passe actuel <span class="req">*</span></label>
    <!-- focus auto ici -->
    <input type="password" v-model="passwordFields.currentPassword" ref="currentPwd" />
    <p v-if="errors.currentPassword" class="error">{{ errors.currentPassword }}</p>
  </div>
  <div class="form-row">
    <label class="label">Nouveau mot de passe <span class="req">*</span></label>
    <input type="password" v-model="passwordFields.newPassword" />
    <p v-if="errors.newPassword" class="error">{{ errors.newPassword }}</p>
  </div>
  <div class="form-row">
    <label class="label">Confirmer le mot de passe <span class="req">*</span></label>
    <input type="password" v-model="passwordFields.confirmPassword" />
    <p v-if="errors.confirmPassword" class="error">{{ errors.confirmPassword }}</p>
  </div>
</div>


        <!-- Actions -->
        <div class="actions">
          <button type="button" class="btn secondary" @click="goBack" :disabled="loading">Annuler</button>
          <button type="submit" class="btn primary" :disabled="loading">
            {{ loading ? 'Enregistrement...' : 'Enregistrer' }}
          </button>
        </div>

        <!-- Messages -->
        <p v-if="success" class="success">Informations mises à jour avec succès.</p>
        <p v-if="serverError" class="error">{{ serverError }}</p>
      </form>
    </div>
  </div>
</template>

<script>
export default {
  name: "EditAccount",
  data() {
    return {
      loading: false,
      success: false,
      serverError: "",
      errors: {},

      // Champs principaux
      form: {
        clientType: "priv",     // 'pro' | 'priv'
        civilite: "Monsieur",   // 'Monsieur' | 'Madame'
        prenom: "",
        nom: "",
        vatNumber: "",
      },

      // Basculers
      editEmail: false,
      editPassword: true,

      // Champs email
      emailFields: {
        newEmail: "",
        confirmEmail: "",
      },

      // Champs mot de passe
      passwordFields: {
        currentPassword: "",
        newPassword: "",
        confirmPassword: "",
      },
    };
  },

  mounted() {
    // Redirige si non connecté
    const isAuth = sessionStorage.getItem("isAuthenticated") === "true";
    if (!isAuth) {
      sessionStorage.setItem("redirectAfterLogin", "/account/edit");
      this.$router.push("/connexion");
      return;
    }

    // Préremplissage depuis la session
    const uStr = sessionStorage.getItem("user");
    if (uStr) {
      try {
        const u = JSON.parse(uStr);
        this.form.civilite   = u.civilite || "Monsieur";
        this.form.prenom     = u.prenom   || "";
        this.form.nom        = u.nom      || "";
        this.form.vatNumber  = u.vatNumber || "";
        this.form.clientType = u.clientType || (u.vatNumber ? "pro" : "priv");
      } catch (err) {
        console.warn("[EditAccount] Parse user échoué", err);
      }
    }
  },

  methods: {
    goBack() {
      this.$router.push("/account");
    },

    enablePasswordEdit() {
      if (!this.editPassword) {
        this.editPassword = true;
      }
      this.$nextTick(() => {
        if (this.$refs.currentPwd) this.$refs.currentPwd.focus();
      });
    },

    validate() {
      this.errors = {};
      if (!this.form.clientType) this.errors.clientType = "Sélectionnez un type de client.";
      if (!this.form.prenom?.trim()) this.errors.prenom = "Le prénom est requis.";
      if (!this.form.nom?.trim()) this.errors.nom = "Le nom est requis.";
      if (this.form.clientType === "pro" && !this.form.vatNumber?.trim()) {
        this.errors.vatNumber = "Le numéro de TVA est requis pour un client professionnel.";
      }

      if (this.editEmail) {
        if (!this.emailFields.newEmail) this.errors.newEmail = "L'email est requis.";
        if (!this.emailFields.confirmEmail) this.errors.confirmEmail = "Confirmez l'email.";
        if (
          this.emailFields.newEmail &&
          this.emailFields.confirmEmail &&
          this.emailFields.newEmail !== this.emailFields.confirmEmail
        ) {
          this.errors.confirmEmail = "Les emails ne correspondent pas.";
        }
      }

      if (this.editPassword) {
        if (!this.passwordFields.currentPassword) this.errors.currentPassword = "Mot de passe actuel requis.";
        if (!this.passwordFields.newPassword) this.errors.newPassword = "Nouveau mot de passe requis.";
        if (!this.passwordFields.confirmPassword) this.errors.confirmPassword = "Confirmez le mot de passe.";
        if (
          this.passwordFields.newPassword &&
          this.passwordFields.confirmPassword &&
          this.passwordFields.newPassword !== this.passwordFields.confirmPassword
        ) {
          this.errors.confirmPassword = "Les mots de passe ne correspondent pas.";
        }
      }

      return Object.keys(this.errors).length === 0;
    },

    async save() {
      if (!this.validate()) return;

      this.loading = true;
      this.success = false;
      this.serverError = "";

      try {
        const token = sessionStorage.getItem("token") || "";
        const payload = {
          clientType: this.form.clientType,
          civilite: this.form.civilite,
          prenom: this.form.prenom.trim(),
          nom: this.form.nom.trim(),
          vatNumber: this.form.vatNumber?.trim() || "",
        };

        if (this.editEmail) {
          payload.newEmail = this.emailFields.newEmail.trim();
        }
        if (this.editPassword) {
          payload.currentPassword = this.passwordFields.currentPassword;
          payload.newPassword = this.passwordFields.newPassword;
        }

        // Adapte l’URL/méthode selon ton back
        const res = await fetch("http://localhost:2028/api/users/me", {
          method: "PATCH",
          headers: {
            "Content-Type": "application/json",
            ...(token ? { Authorization: `Bearer ${token}` } : {}),
          },
          body: JSON.stringify(payload),
        });

        const data = await res.json().catch(() => ({}));
        if (!res.ok) {
          throw new Error(data.message || "Échec de la mise à jour.");
        }

        // Met à jour la session locale
        const existingStr = sessionStorage.getItem("user");
        let existing = {};
        try {
          existing = existingStr ? JSON.parse(existingStr) : {};
        } catch (err) {
          console.warn("[EditAccount] Parse user échoué", err);
        }

        const updated = {
          ...existing,
          ...payload,
          ...(data.user || {}), // si l'API renvoie l'objet user complet
        };

        if (data.user?.email) updated.email = data.user.email;
        else if (payload.newEmail) updated.email = payload.newEmail;

        sessionStorage.setItem("user", JSON.stringify(updated));

        this.success = true;
        // setTimeout(() => this.$router.push("/account"), 800);
      } catch (e) {
        this.serverError = e.message || "Erreur serveur.";
      } finally {
        this.loading = false;
      }
    },
  },

  watch: {
    // Nettoyage des champs/erreurs quand on décoche
    editPassword(newVal) {
      if (!newVal) {
        this.passwordFields.currentPassword = "";
        this.passwordFields.newPassword = "";
        this.passwordFields.confirmPassword = "";
        delete this.errors.currentPassword;
        delete this.errors.newPassword;
        delete this.errors.confirmPassword;
      }
    },
    editEmail(newVal) {
      if (!newVal) {
        this.emailFields.newEmail = "";
        this.emailFields.confirmEmail = "";
        delete this.errors.newEmail;
        delete this.errors.confirmEmail;
      }
    },
  },
};
</script>

<style scoped>
/*MODE CLAIR (par défaut) */
.account-edit-page {
  display: flex;
  justify-content: center;
  padding: 16px;
  background: #f7f7f7;
  color: #333;
}

.card {
  width: 100%;
  max-width: 760px;
  background: #fff;
  border-radius: 10px;
  box-shadow: 0 1px 4px rgba(0,0,0,0.08);
  overflow: hidden;
}

.card-header {
  padding: 18px 20px 6px;
  border-bottom: 1px solid #eee;
}

.card-header h2 {
  margin: 0;
  font-size: 20px;
  color: #222;
}

.subtitle {
  margin: 6px 0 0 0;
  font-size: 14px;
  color: #666;
}

.form {
  padding: 18px 20px 22px;
}

.form-row {
  margin-bottom: 14px;
  display: flex;
  flex-direction: column;
}

.label {
  font-size: 14px;
  color: #333;
  margin-bottom: 6px;
}

.req {
  color: #e53935;
}

input[type="text"],
input[type="email"],
input[type="password"],
select {
  width: 100%;
  padding: 10px 12px;
  border: 1px solid #ddd;
  border-radius: 6px;
  font-size: 14px;
  outline: none;
  background-color: #fff;
  color: #333;
}

input:focus,
select:focus {
  border-color: #2aa198;
}

.radio-group {
  display: flex;
  gap: 22px;
  align-items: center;
}

.checkbox-row {
  margin-top: 8px;
}

.fieldset {
  border: 1px solid #eee;
  border-radius: 8px;
  padding: 12px;
  background: #fafafa;
  margin-top: 6px;
}

.actions {
  display: flex;
  gap: 10px;
  margin-top: 10px;
}

.btn {
  padding: 10px 16px;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  font-weight: 600;
}

.btn.primary {
  background: #0a8f7d;
  color: #fff;
}

.btn.primary:disabled {
  opacity: 0.7;
  cursor: not-allowed;
}

.btn.secondary {
  background: #e7eaee;
  color: #333;
}

.error {
  color: #e53935;
  font-size: 13px;
  margin-top: 6px;
}

.success {
  color: #1b8f4d;
  margin-top: 10px;
  font-weight: 600;
}

/*MODE SOMBRE (automatique et .dark-mode) */
@media (prefers-color-scheme: dark) {
  .account-edit-page {
    background: #121212;
    color: #e0e0e0;
  }

  .card {
    background: #1e1e1e;
    box-shadow: 0 1px 4px rgba(255,255,255,0.05);
    border: 1px solid #333;
  }

  .card-header {
    border-bottom: 1px solid #333;
  }

  .card-header h2 {
    color: #f1f1f1;
  }

  .subtitle {
    color: #aaa;
  }

  .label {
    color: #ddd;
  }

  input[type="text"],
  input[type="email"],
  input[type="password"],
  select {
    background-color: #2b2b2b;
    border: 1px solid #555;
    color: #f1f1f1;
  }

  input:focus,
  select:focus {
    border-color: #00bfa5;
  }

  .fieldset {
    background: #1c1c1c;
    border: 1px solid #444;
  }

  .btn.primary {
    background: #00bfa5;
  }

  .btn.primary:hover {
    background: #00998b;
  }

  .btn.secondary {
    background: #333;
    color: #eee;
  }

  .error {
    color: #ef5350;
  }

  .success {
    color: #4caf50;
  }
}

/*Mode sombre forcé via .dark-mode */
.dark-mode.account-edit-page {
  background: #121212;
  color: #e0e0e0;
}

.dark-mode .card {
  background: #1e1e1e;
  box-shadow: 0 1px 4px rgba(255,255,255,0.05);
  border: 1px solid #333;
}

.dark-mode .card-header {
  border-bottom: 1px solid #333;
}

.dark-mode .card-header h2 {
  color: #f1f1f1;
}

.dark-mode .subtitle {
  color: #aaa;
}

.dark-mode .label {
  color: #ddd;
}

.dark-mode input[type="text"],
.dark-mode input[type="email"],
.dark-mode input[type="password"],
.dark-mode select {
  background-color: #2b2b2b;
  border: 1px solid #555;
  color: #f1f1f1;
}

.dark-mode input:focus,
.dark-mode select:focus {
  border-color: #00bfa5;
}

.dark-mode .fieldset {
  background: #1c1c1c;
  border: 1px solid #444;
}

.dark-mode .btn.primary {
  background: #00bfa5;
}

.dark-mode .btn.primary:hover {
  background: #00998b;
}

.dark-mode .btn.secondary {
  background: #333;
  color: #eee;
}

.dark-mode .error {
  color: #ef5350;
}

.dark-mode .success {
  color: #4caf50;
}
</style>